<template>
  <div class="animated fadeIn">

    <b-row>
     <b-col lg="12">
        <!--<c-table-entities striped caption="<i class='fa fa-align-justify'></i> Liste des entités"></c-table-entities>-->
          <div>
              <vue-good-table styleClass="vgt-table condensed bordered striped" :columns="columns" :rows="rows" :row-style-class="rowStyleClassFn" :fixed-header="false" :pagination-options="pagination" :search-options="search" :totalRows="totalRecords" mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter">
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'btn'" style="font-size: 0.875rem;">
                        
                          <b-dropdown id="ddown-sm-split" size="sm" text="Plus de détails" class="m-2">
                            <div role="group" aria-lableledby="header1">                   
                                <router-link :to="'edit/' + props.row.id" v-if="can('user-edit')"><b-dropdown-item-button aria-describedby="header1" :id="props.row.id"><i class="fa fa-edit"></i> Modifier</b-dropdown-item-button></router-link>
                                <!-- <b-dropdown-item-button aria-describedby="header1" v-if="can('user-delete')" @click.prevent="confirm()"><i class="fa fa-trash"></i> Désactiver</b-dropdown-item-button> -->
                                <!-- <router-link :to="'show/' + props.row.id" v-if="can('user-list-responsable')"><b-dropdown-item-button aria-describedby="header1"><i class="fa fa-eye"></i> Plus d'infos</b-dropdown-item-button></router-link> -->
                            </div>  
                            <div role="group" aria-lableledby="header2">
                              <b-dropdown-header id="header2">Autres actions ...</b-dropdown-header>   
                                <router-link :to="'/transferts/list/user/'+ props.row.id" v-if="can('operation-list-by-user')">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Opérations</b-dropdown-item-button>
                                </router-link>
                                <router-link :to="'/plannings/user/list/'+ props.row.id" v-if="can('planning-list-by-user')">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-calendar"></i> Plannings</b-dropdown-item-button>
                                </router-link>
                                <router-link :to="'/approvisionnements/user/list/'+ props.row.id" v-if="can('approvisionnement-list-by-user')">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Approvisionnements</b-dropdown-item-button>
                                </router-link>
                              <!--<b-dropdown-item-button aria-describedby="header2">Delete</b-dropdown-item-button>-->
                            </div>              
                          </b-dropdown>
                    </span>
                    <span v-if="props.column.field == 'valeur'" style="font-size: 0.875rem;">
                        {{props.formattedRow[props.column.field]}}
                    </span>
                    <span style="font-size: 0.875rem;" v-else>
                      {{props.formattedRow[props.column.field]}}
                    </span>
                  </template>    
              </vue-good-table>
          </div>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
//import cTableEntities from './TableEntities.vue'
import { VueGoodTable } from 'vue-good-table';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'tables',
  //components: {cTableEntities},
  components: {VueGoodTable},
   data(){
    return {
      totalRecords :0,
      columns: [
        {
          label: 'Actions',
          field: 'event',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Adresse IP',
          field: 'ip_address',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Utilisateur',
          field: 'username',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Email',
          field: 'email',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Navigateur',
          field: 'user_agent',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Valeur',
          field: 'valeur',
          html: true,
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Appliqué le',
          field: 'created_at',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'YYYY-MM-DD',
          filterable: true,width: '180px',
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        }
      ],
      rows: [],
      pagination:{
          enabled: true,
          mode: 'pages',
          perPage: 10,
          position: 'bottom',
          perPageDropdown: [3,5, 10, 50,100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Suivant',
          prevLabel: 'Précédent',
          rowsPerPageLabel: 'Lignes par page',
          ofLabel: 'de',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
      },
      search:{
          enabled: false,
          trigger: 'keyup',
          placeholder: 'Rechercher dans la table',
      },
      serverParams: {
        name:'',
        email:'',
        entite_nom:'',
        agence_nom:'',
        agence_ville:'',
        role_name:'',
        created_at:'',
        page:1,
        current_page: 1,
        nb_lines:10
      }
    };
  },
  methods:{
    hideModal () {
    this.$refs.myModalRef.hide()
    },
    async cancel_delete(){
        this.hideModal()
    },
    async confirm(){
        this.$refs.myModalRef.show()
    },
    rowStyleClassFn(row) {
      return row.role === 'Operateur de Distributeur' ? 'green' : 'red';
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    async get_all_users(){
        this.$store.dispatch('user/get_all_users').then(()=>{
          return this.rows =  store.getters['user/rows'];
        })
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.serverParams.page = params.currentPage
      this.updateParams({page: params.currentPage,current_page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.serverParams.nb_lines = params.currentPerPage
      console.log(params)
      this.updateParams({page: params.currentPage,paginate:params.currentPerPage});
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
      });
      this.loadItems();
    },    
    onColumnFilter(params) {
      this.serverParams.name=params.columnFilters.name,
      this.serverParams.email=params.columnFilters.email,
      this.serverParams.entite_nom=params.columnFilters.entite_nom,
      this.serverParams.agence_nom=params.columnFilters.agence_nom,
      this.serverParams.agence_ville=params.columnFilters.agence_ville,
      this.serverParams.role_name=params.columnFilters.role_name,
      this.serverParams.created_at=params.columnFilters.created_at,
      this.updateParams(params);
      this.loadItems();
    },
    // load items is what brings back the rows from server
    loadItems() {
      this.$store.dispatch('histories/get_histories_by_agency',this.$route.params.agence_id).then((response)=>{
          //console.log(response)
          this.totalRecords = response.total;
          this.rows =  store.getters['histories/rowsAgency'];
          //console.log(this.rows)
          return this.rows
      })
    }
  },
  mounted(){
    // this.get_all_users()
    this.loadItems()
  }
  
}
</script>
